import { observer, use$ } from '@legendapp/state/react';
import { Button, Group, Stack, Text } from '@mantine/core';
import type { ContextModalProps } from '@mantine/modals';
import Decimal from 'decimal.js';
import { useTranslation } from 'react-i18next';
import { configurationState$ } from '../state';

export const GameLimitsModal = observer(
  ({ context, id }: ContextModalProps) => {
    const { minBet, maxBet, currency, maxWin, decimalScale } =
      use$(configurationState$);
    const { t } = useTranslation();

    return (
      <Stack data-test-id="game-limits-modal">
        <Stack data-test-id="game-limits-content" gap={2}>
          <Group
            data-test-id="game-limits-min-bet-group"
            justify="space-between"
          >
            <Text data-test-id="game-limits-min-bet-label" size="sm">
              {t('gameLimitsModal.minBetLabel')}:
            </Text>
            <Text data-test-id="game-limits-min-bet-value" size="sm">
              {new Decimal(minBet)
                .toDecimalPlaces(decimalScale, Decimal.ROUND_DOWN)
                .toNumber()}{' '}
              {currency}
            </Text>
          </Group>
          <Group
            data-test-id="game-limits-max-bet-group"
            justify="space-between"
          >
            <Text data-test-id="game-limits-max-bet-label" size="sm">
              {t('gameLimitsModal.maxBetLabel')}:
            </Text>
            <Text data-test-id="game-limits-max-bet-value" size="sm">
              {new Decimal(maxBet)
                .toDecimalPlaces(decimalScale, Decimal.ROUND_DOWN)
                .toNumber()}{' '}
              {currency}
            </Text>
          </Group>
          <Group
            data-test-id="game-limits-max-win-group"
            justify="space-between"
          >
            <Text data-test-id="game-limits-max-win-label" size="sm">
              {t('gameLimitsModal.maxWinLabel')}:
            </Text>
            <Text data-test-id="game-limits-max-win-value" size="sm">
              {new Decimal(maxWin)
                .toDecimalPlaces(decimalScale, Decimal.ROUND_DOWN)
                .toNumber()}{' '}
              {currency}
            </Text>
          </Group>
        </Stack>
        <Button
          data-test-id="game-limits-close-button"
          fullWidth
          mb={16}
          onClick={() => context.closeModal(id)}
        >
          {t('gameLimitsModal.confirmButtonLabel')}
        </Button>
      </Stack>
    );
  }
);
